<template>
  <div class="content-wrapper">
    <div class="content-header">
      <div
        class="d-flex align-items-center"
        style="border-bottom: 1px solid #5c4a4a17; margin: auto !important"
      >
        <div class="row">
          <div class="col-sm-6 d-flex flex-column align-items-baseline">
            <h1 class="m-0 text-dark">Files</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <li class="breadcrumb-item active">Files:</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- Data Table -->
    <!-- :sort-by="['cTime']"
    :sort-desc="[true]" -->
    <v-card>
      <v-data-table :headers="headers" :items="items" :loading="loading">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              Files
              <v-btn icon color="primary" x-small @click="refreshList">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  :loading="loading || fileInProgress"
                >
                  Custom Export
                </v-btn>
              </template>

              <v-card style="margin: 0 !important">
                <v-card-title>
                  <span class="text-h5">Custom Export</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="8">
                        <!-- Domains List -->
                        <v-autocomplete
                          v-model="selectedDomains"
                          :items="domains"
                          full-width
                          outlined
                          dense
                          label="Select a Domain*"
                          item-text="url"
                          item-value="id"
                          multiple
                          :filter="returnFilteredDomains"
                          :height="34"
                          :loading="fileInProgress"
                          :disabled="fileInProgress"
                        >
                          <template v-slot:selection="{ item, index }">
                            <v-chip
                              v-if="
                                index === 0 &&
                                selectedDomains.length < domains.length
                              "
                            >
                              {{ item.url }}
                            </v-chip>
                            <span
                              v-if="
                                index === 1 &&
                                selectedDomains.length !== domains.length
                              "
                              class="mr-1 ma-2 grey--text text-caption"
                            >
                              (+ {{ selectedDomains.length - 1 }})
                            </span>
                            <v-chip
                              v-else-if="
                                index === 0 &&
                                selectedDomains.length === domains.length
                              "
                            >
                              All Domains
                            </v-chip>
                          </template>
                          <template v-slot:prepend-item>
                            <v-list-item
                              ripple
                              @click="
                                selectedDomains.length === domains.length
                                  ? (selectedDomains = [])
                                  : (selectedDomains = domains.map(
                                      (el) => el.id
                                    ))
                              "
                            >
                              <v-list-item-action>
                                <v-icon
                                  :color="
                                    selectedDomains.length > 0
                                      ? 'indigo darken-4'
                                      : ''
                                  "
                                  >{{ icon }}</v-icon
                                >
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title
                                  >Select All</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="8">
                        <!-- Calendar -->
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          :return-value.sync="datePicker"
                          :max="maxDate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                          style="max-height: 400px !important"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="datePickerRangeText"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              outlined
                              dense
                              full-width
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="datePicker"
                            range
                            no-title
                            scrollable
                            :min="minDate"
                            :max="maxDate"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu = false">
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(datePicker)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="8">
                        <!-- Date Range -->
                        <v-autocomplete
                          :items="[
                            { text: 'Hour', value: 'hour' },
                            { text: 'Day', value: 'day' },
                            { text: 'Week', value: 'week' },
                            { text: 'Month', value: 'month' },
                          ]"
                          full-width
                          outlined
                          dense
                          v-model="dateRange"
                          :height="34"
                          :loading="fileInProgress"
                          :disabled="fileInProgress"
                          class="mr-1"
                        ></v-autocomplete>
                        <!-- Timezone list -->
                        <v-autocomplete
                          v-model="selectedTimezone"
                          :items="timezones"
                          full-width
                          outlined
                          dense
                          label="Timezone*"
                          :height="34"
                          :loading="fileInProgress"
                          :disabled="fileInProgress"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="4">
                        <!-- Group By -->
                        <v-select
                          v-model="groupBySelectValue"
                          :items="groupByList"
                          full-width
                          outlined
                          dense
                          multiple
                          label="Group By:"
                          :height="34"
                          :loading="fileInProgress"
                          :disabled="fileInProgress"
                        ></v-select>
                        <!-- Date Type -->
                        <v-select
                          :items="[
                            { text: 'Drips', value: 'drips' },
                            { text: 'Subs', value: 'subs' },
                            { text: 'Errors', value: 'errors' },
                          ]"
                          full-width
                          outlined
                          dense
                          v-model="selectedDataVariant"
                          label="Data Type*"
                          :height="34"
                          :loading="fileInProgress"
                          :disabled="fileInProgress"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    :loading="fileInProgress"
                    text
                    @click="dialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    :loading="fileInProgress"
                    text
                    @click="checkFieldsToDownload"
                  >
                    Export
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <span @click="openTab(item.link)">
            {{ item.basename }}
          </span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            class="ma-2"
            color="green"
            text-color="white"
            small
            v-if="item.isPending === undefined"
          >
            Completed
          </v-chip>
          <v-chip
            class="ma-2"
            color="#ff9800"
            style="padding: 0 27px 0 6px"
            outlined
            label
            small
            v-if="item.isPending !== undefined"
          >
            <span class="mr-1">In Process</span>
            <div class="loader--dots files-dots-loader--l"></div>
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                :loading="fileLoading || loading"
                :disabled="fileLoading || loading || item.link === null"
                label
                color="#1976d2"
                small
                text
                fab
                @click="openTab(item.link)"
                class="mr-2"
              >
                <v-icon center small> mdi-cloud-download </v-icon>
              </v-btn>
            </template>
            <span>Click to download</span>
          </v-tooltip>
          <v-btn
            :loading="fileLoading || loading"
            :disabled="fileLoading || loading"
            label
            color="error"
            small
            text
            fab
            @click="
              selectedFileBasenameToDelete = item.basename;
              isConfirmDialogVisible = true;
            "
          >
            <v-icon center small> mdi-trash-can-outline </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Success Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        @update-success="handleUpdateToSuccessSnackbar"
        :message="successText"
      />
    </transition>

    <!-- Failure Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        @update-failure="handleUpdateToFailureSnackbar"
        :message="failureText"
      />
    </transition>

    <!-- Question Dialog -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <Question
        v-if="isConfirmDialogVisible"
        @didClose="isConfirmDialogVisible = false"
        @confirmed="removeFile"
        @notConfirmed="selectedFileBasenameToDelete = null"
        title="Are you sure you want to delete this file?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        dismissTitle="Canceled!"
        confirmButtonClasses="btn btn-success"
        cancelButtonClasses="btn btn-success"
        successIcon="success"
        errorIcon="error"
      />
    </transition>
  </div>
</template>

<script>
// Realize maxdate in the calendar
const momentTimezone = require("moment-timezone");

import moment from "moment";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Question from "../popUps/Question.vue";

import { mapState, mapActions } from "vuex";

import Statistics from "../../apis/Statistics";

import common from "../../mixins/common";
import statistics from "../../mixins/statistics";
import { EchoService } from "../../services/EchoService";

export default {
  name: "Files",
  mixins: [common, statistics],
  components: {
    SuccessSnackbar,
    FailureSnackbar,
    Question,
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "basename",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Extension",
          value: "extension",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Created Time",
          value: "cTime",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Size",
          value: "size",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
          align: "center",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "center",
          divider: true,
          class:
            "table-header--color d-flex align-items-center justify-content-center",
        },
      ],

      isConfirmDialogVisible: false,
      dialog: false,
      menu: false,
      items: [],
      groupByList: [
        { value: "drip_id", text: "Drip Id" },
        { value: "website_id", text: "Website Id" },
        { value: "type", text: "Type" },
      ],

      selectedDataVariant: "",

      minDate: moment().subtract(1, "years").format("YYYY-MM-DD"),
      maxDate: moment().format("YYYY-MM-DD"),

      timezones: momentTimezone.tz.names(),

      loading: false,
      fileLoading: false,

      selectedFileBasenameToDelete: null,
      success: false,
      successText: "Success!",
      failure: false,
      failureText: "Error!",
    };
  },
  computed: {
    ...mapState({
      domains: (state) => state.domain.domains,
    }),

    icon() {
      if (this.selectedDomains.length === this.domains.length)
        return "mdi-close-box";
      if (
        this.selectedDomains.length &&
        this.selectedDomains.length < this.domains.length
      )
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  created() {
    this.loading = true;
    const echoInstance = new EchoService();

    echoInstance.listen("files", ".file.status-updated", (response) => {
      console.log("echo message", response, response?.status === "ready");
      if (response?.status === "in_progress") {
        let modifiedResponse = response;
        modifiedResponse.isPending = true;

        this.$set(this.items, 0, modifiedResponse);
      }

      if (response?.status === "ready" || response?.status === "failed") {
        this.loading = false;
        this.fileInProgress = false;
        delete this.items[0].isPending;
      }

      if (response?.status === "ready" || response?.status === "failed") {
        this.$set(this.items, 0, response);
      }

      if (response?.status === "failed") {
        this.failureText = "Failed to generate file.";
        this.failure = true;
      }
    });
  },
  mounted() {
    this.show();
    this.getFilesList()
      .then((response) => {
        console.log("🚀 ~ .then ~ response:", response);
        this.items.push(response.ready);
        this.items.push(response.in_progress);

        this.items = this.items.flat(Infinity);
      })
      .catch((error) => {
        this.failureText = error;
        this.failure = true;
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });

    this.selectedDataVariant = "drips";

    //this.checkFileStatus();
  },
  methods: {
    ...mapActions(["show"]),

    returnFilteredDomains(item, queryText, itemText) {
      return (
        item.url.toLocaleLowerCase().includes(queryText.toLocaleLowerCase()) ||
        item.id == queryText.toLocaleLowerCase()
      );
    },
    removeFile() {
      this.isConfirmDialogVisible = false;
      this.loading = true;

      Statistics.removeFile(this.selectedFileBasenameToDelete)
        .then(() => {
          let fileIndex = this.items.findIndex(
            (el) => el.basename === this.selectedFileBasenameToDelete
          );
          this.items.splice(fileIndex, 1);

          this.successText = "The file has been successfully removed.";
          this.success = true;
        })
        .catch((error) => {
          if (error.response) {
            this.failureText = error.response.message || "Error!";
            this.failure = true;
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1500);
        });
    },
    refreshList() {
      this.loading = true;
      this.fileLoading = true;

      this.getFilesList()
        .then((response) => {
          let responseData = [];
          let unique = [];

          responseData.push(this.items);
          responseData.push(response.ready);
          responseData.push(response.in_progress);

          responseData = responseData.flat(Infinity);

          unique = [
            [
              ...new Map(
                responseData.map((item) => [item["basename"], item])
              ).values(),
            ],
          ];

          this.items = unique[0];
        })
        .catch((error) => {
          this.failureText = error;
          this.failure = true;
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.fileLoading = false;
          }, 1000);
        });
    },
    async checkFieldsToDownload() {
      if (
        this.groupBySelectValue &&
        this.selectedDataVariant &&
        this.datePicker &&
        this.dateRange &&
        this.selectedTimezone &&
        this.selectedDomains.length
      ) {
        this.loading = true;

        try {
          console.log("🚀 ~ .then ~ fileName starts:");
          const result = await this.downloadFile();
          const fileName = result.data.data.path.split("/").pop();
          console.log("🚀 ~ .then ~ fileName:", fileName);

          if (this.items[0].basename === fileName) return;
        } catch (error) {
          this.failureText =
            error?.response?.message || error || "Failed to generate file.";
          this.loading = false;
          this.fileInProgress = false;
        }

        queueMicrotask(() => {
          setTimeout(() => {
            this.dialog = false;
          }, 1000);
        }, 1000);

        return true;
      } else {
        this.failureText = "Fill out the required fields!";
        this.failure = true;

        return false;
      }
    },
  },
};
</script>
